import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Toggle } from '@checkmarx/cx-ui';
import { LdapEditMode } from '../../../services/enums/ldap';
import PortalTextBox from '../../portal/portalTextBox';
import PortalCheckBox from '../../portal/controls/checkbox';
import {
    HostNameHelpTooltip, PortHelpTooltip, ServerNameHelpTooltip,
    UserNameTooltip, PasswordTooltip
} from './ldapHelpTooltipContent';
import TextfieldFloatingText from '../../portal/textfieldFloatingText';

@inject('translationsStore') @observer
export default class LdapServerSettingsForm extends Component {

    currentLdapStore = this.props.currentLdapStore;
    ldapValidator = this.props.ldapValidator;

    handleChangeActive = e => this.props.currentLdapStore.setActive(e.target.checked);

    handleChangeDefault = e => this.props.currentLdapStore.setDefaultMethod(e.target.checked);

    handleServerNameChange = e => this.props.currentLdapStore.setName(e.target.value);
    handleServerNameOnBlur = e => {
        this.props.currentLdapStore.setName(e.target.value.trim());
        this.ldapValidator.validateServerName(this.currentLdapStore.name);
    }

    handleHostChange = e => this.props.currentLdapStore.setHost(e.target.value);
    handleHostOnBlur = e => {
        this.props.currentLdapStore.setHost(e.target.value.trim());
        this.ldapValidator.validateHost(this.currentLdapStore.host);
    }

    handlePortChange = e => this.props.currentLdapStore.setPort(e.target.value);
    handlePortOnBlur = e => {
        this.props.currentLdapStore.setPort(e.target.value.trim());
        this.ldapValidator.validatePort(this.currentLdapStore.port);
    }

    handleChangeUserName = e => this.props.currentLdapStore.setUsername(e.target.value);
    handleUserNameOnBlur = e => {
        this.props.currentLdapStore.setUsername(e.target.value.trim());
        this.ldapValidator.validateUserName(this.currentLdapStore.username);
    }

    handleChangePassword = e => this.props.currentLdapStore.setPassword(e.target.value);
    handlePasswordOnBlur = e => this.ldapValidator.validatePassword(this.currentLdapStore.password);

    useSSLChange = () => {

        this.props.currentLdapStore.setUseSsl(!this.props.currentLdapStore.useSsl);

        if (this.props.currentLdapStore.useSsl == false) {

            this.props.currentLdapStore.setVerifySSLCertificate(false);
        }
    }

    verifySSLCertificateChange = () => this.props.currentLdapStore.setVerifySSLCertificate(!this.props.currentLdapStore.verifySSLCertificate);

    render() {

        let fieldIdSuffix = 'add';

        if (this.props.mode == LdapEditMode.update) {

            fieldIdSuffix = this.currentLdapStore.id;
        }

        return (
            <div className='ldap-server-settings-form-main-wrapper'>
                <div className='form-row enable-server'>
                    <Toggle
                        dataCy='tgl-enable-server'
                        className='enable-ldap-server'
                        icons={false}
                        onChange={this.handleChangeActive}
                        disabled={this.currentLdapStore.createUpdateLDAPServersProgress}
                        checked={this.currentLdapStore.active}
                        text={this.props.translationsStore.translate('ENABLE_LDAP_SERVER')}
                        helpTooltipText={this.props.translationsStore.translate('DISABLING_LDAP_HELP_TOOLTIP')}
                    />
                </div>
                <div className='form-row inputs'>
                    <PortalTextBox
                        dataCy={'txt-server-name'}
                        hintText={this.props.translationsStore.translate('SERVER_NAME')}
                        floatingLabelText={<TextfieldFloatingText title={this.props.translationsStore.translate('SERVER_NAME')}
                            required={true} />}
                        width='47%'
                        disabled={this.currentLdapStore.createUpdateLDAPServersProgress}
                        onChange={this.handleServerNameChange}
                        onBlur={this.handleServerNameOnBlur}
                        errorText={this.ldapValidator.serverNameValidationMessage}
                        value={this.currentLdapStore.name}
                        helpTooltipText={<ServerNameHelpTooltip />}
                    />
                </div>
                <div className='form-row start'>
                    <PortalTextBox
                        dataCy={'txt-host-name'}
                        hintText={this.props.translationsStore.translate('HOST_NAME')}
                        floatingLabelText={<TextfieldFloatingText title={this.props.translationsStore.translate('HOST_NAME')}
                            required={true} />}
                        width='47%'
                        disabled={this.currentLdapStore.createUpdateLDAPServersProgress}
                        onChange={this.handleHostChange}
                        onBlur={this.handleHostOnBlur}
                        errorText={this.ldapValidator.hostValidationMessage}
                        value={this.currentLdapStore.host}
                        helpTooltipText={<HostNameHelpTooltip />}
                    />
                    <PortalTextBox
                        dataCy={'txt-port'}
                        hintText={this.props.translationsStore.translate('PORT')}
                        floatingLabelText={<TextfieldFloatingText title={this.props.translationsStore.translate('PORT')}
                            required={true} />}
                        width='20%'
                        disabled={this.currentLdapStore.createUpdateLDAPServersProgress}
                        onChange={this.handlePortChange}
                        onBlur={this.handlePortOnBlur}
                        errorText={this.ldapValidator.portValidationMessage}
                        value={this.currentLdapStore.port}
                        helpTooltipText={<PortHelpTooltip />}
                    />
                </div>
                <div className='form-row'>
                    <PortalTextBox
                        dataCy={'txt-username'}
                        hintText={this.props.translationsStore.translate('USER_NAME')}
                        floatingLabelText={<TextfieldFloatingText title={this.props.translationsStore.translate('USER_NAME')}
                            required={true} />}
                        width='47%'
                        disabled={this.currentLdapStore.createUpdateLDAPServersProgress}
                        onChange={this.handleChangeUserName}
                        onBlur={this.handleUserNameOnBlur}
                        errorText={this.ldapValidator.usernameValidationMessage}
                        value={this.currentLdapStore.username}
                        helpTooltipText={<UserNameTooltip />}
                    />
                    <PortalTextBox
                        dataCy={'txt-password'}
                        hintText={this.props.translationsStore.translate('PASSWORD')}
                        floatingLabelText={<TextfieldFloatingText title={this.props.translationsStore.translate('PASSWORD')}
                            required={true} />}
                        type='password'
                        width='47%'
                        disabled={this.currentLdapStore.createUpdateLDAPServersProgress}
                        onChange={this.handleChangePassword}
                        onBlur={this.handlePasswordOnBlur}
                        errorText={this.ldapValidator.passwordValidationMessage}
                        value={this.currentLdapStore.password || ''}
                        helpTooltipText={<PasswordTooltip />}
                    />
                </div>
                <div className='form-row use-ssl'>
                    <PortalCheckBox
                        dataCy='cbx-use-ssl'
                        checked={this.currentLdapStore.useSsl}
                        disabled={this.currentLdapStore.createUpdateLDAPServersProgress}
                        label={this.props.translationsStore.translate('USE_SSL')}
                        onCheck={this.useSSLChange}
                    />
                </div>
                {
                    this.currentLdapStore.useSsl ?
                        <div className='form-row verify-ssl'>
                            <PortalCheckBox
                                dataCy='cbx-verify-ssl-certificate'
                                checked={this.currentLdapStore.verifySSLCertificate}
                                disabled={this.currentLdapStore.createUpdateLDAPServersProgress || !this.currentLdapStore.useSsl}
                                label={this.props.translationsStore.translate('VERIFY_SSL_CERTIFICATE')}
                                onCheck={this.verifySSLCertificateChange}
                            />
                        </div> :
                        null
                }
                <div className='form-row enable-server'>
                    <Toggle
                        dataCy='tgl-default-server'
                        className='enable-ldap-server'
                        icons={false}
                        onChange={this.handleChangeDefault}
                        checked={this.currentLdapStore.defaultMethod}
                        text={this.props.translationsStore.translate('DEFAULT_LDAP_SERVER')}
                        helpTooltipText={this.props.translationsStore.translate('SET_DEFAULT_LDAP_HELP_TOOLTIP')}
                    />
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ldap/forms/ldapServerSettingsForm.jsx